import request from '@/config/axios'

export interface CatalogInstPricingVO {
  id?: number
  institutionId?: number
  serviceId?: number
  basePrice?: number
  applyPrice?: number
  floatRatio?: number
  status?: string
  rejectReason?: string
  auditorId?: number
  auditTime?: string
  effectiveTime?: string
  remark?: string
  createTime?: string
}

export const CatalogInstPricingApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/catalog/inst-pricing/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/catalog/inst-pricing/get?id=' + id })
  },
  audit: async (data: { id: number; passed: boolean; rejectReason?: string }) => {
    return await request.put({ url: '/o2o/catalog/inst-pricing/audit', data })
  }
}
